import { ObjectValues } from 'components/common/react-types'

export const TOAST_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
} as const

export type ToastType = ObjectValues<typeof TOAST_TYPES>
